<template>
  <div class="pdf-preview">
    <h1 class="title">
      中国质量协会第{{ num }}届理事会<br />{{ zhiwei }}候选人推荐表
    </h1>
    <div class="category">
      <div class="category-wrapper">
        <div class="category-title">类别:</div>
        <span>{{ professions }}</span>
        <!--<ul class="category-list">
          <li v-for="(item, index) in category" :key="index" :class="item.isChecked? 'checked': ''">
            <input type="checkbox" disabled :checked="item.isChecked">{{item.name}}</li>
        </ul>-->
      </div>
      <ul class="pdf-details">
        <li class="first-line">
          <span>姓名</span>
          <span>{{ form_name }}</span>
          <span>性别</span>
          <span>{{ sex }}</span>
          <span>出生日期</span>
          <span>{{ data1 }}</span>
          <span>民族</span>
          <span>{{ people_kind }}</span>
        </li>
        <li class="second-line">
          <span>身份证号</span>
          <span>{{ form_code }}</span>
          <span>中管干部</span>
          <span>
            <label for="">
              是
              <input type="checkbox" disabled :checked="yes" />
            </label>
            <label for="">
              否
              <input type="checkbox" disabled :checked="no" />
            </label>
          </span>
        </li>
        <li class="third-line">
          <span>工作单位</span>
          <span>{{ danwei }}</span>
          <span>职务</span>
          <span>{{ zhiwu }}</span>
        </li>
        <li class="fourth-line">
          <span>政治面貌</span>
          <span>{{ zzmm }}</span>
          <span>学位:{{ xw }}</span>
          <span>学历:{{ xl }}</span>
          <span>专业</span>
          <span>{{ zy }}</span>
        </li>
        <li class="fifth-line">
          <span>专业技术职称</span>
          <span>{{ zc }}</span>
          <span>在其他社团组织中担任何领导职务</span>
          <span>{{ yet_leader }}</span>
        </li>
        <li class="sixth-line">
          <span>通信地址</span>
          <span>{{ txdz }}</span>
          <span>邮编</span>
          <span>{{ yb }}</span>
        </li>
        <li class="seventh-line">
          <span>联系电话</span>
          <span>{{ lxdh }}</span>
          <span>传真</span>
          <span>{{ cz }}</span>
        </li>
        <li class="eighth-line">
          <span>手机</span>
          <span>{{ sj }}</span>
          <span>电子邮箱</span>
          <span>{{ dzyx }}</span>
        </li>
        <li class="nineth-line">
          <span class="nine-name">工作经历</span>
          <span class="nine-details">
            <span class="nine-tit">
              <span>起止时间</span>
              <span class="letter-style">单位</span>
              <span class="letter-style">职务</span>
            </span>
            <span class="nine-desc" style="white-space: pre-wrap">{{
              area
            }}</span>
          </span>
        </li>
        <li class="tenth-line">
          <span>推荐担任{{ zhiwei }}职务<br />及 <br />本人承诺</span>
          <span>
            <div class="desc">
              本人同意担任中国质量协会{{
                zhiwei
              }}职务,按时出席中国质协主要会议和重大活动,愿意为实施质量兴国战略。推进中国质量事业作出贡献。
            </div>
            <div class="signature">
              <em> 签名: </em>
              <div class="date">
                <em>年</em>
                <em>月</em>
                <em>日</em>
              </div>
            </div>
          </span>
          <span>所在工作单位意见</span>
          <span>
            <em class="common">(公章)</em><br />
            <div class="date">
              <em>年</em>
              <em>月</em>
              <em>日</em>
            </div>
          </span>
        </li>
      </ul>
    </div>
    <div class="footer">
      <p>
        联系人姓名：<span>{{ lName }}</span> 联系人职务：<i>{{ lPost }}</i>
      </p>
      <p>
        联系人电话：<span>{{ lPhone }}</span> 联系人邮箱：<i>{{ lEmail }}</i>
      </p>
      <p>※敬请于2周内, 将本表书面形式寄至中国质协指定单位</p>
      <p>地址( 邮编 ) ： 北京市海淀区三虎桥百胜村6号(100048)</p>
      <p>联系人及联系方式：</p>
      <p>
        韩恵 <em>(010) 68417208</em> &nbsp;&nbsp;宋月琳
        <em>(010) 66072472</em> &nbsp;&nbsp;赵玉翠 <em>(010) 66013615</em>
      </p>
    </div>
  </div>
</template>

<script>
//	import { Loading } from 'element-ui';
//	import area from '../../static/js/area.js';
import Qs from 'qs';
export default {
  data () {
    return {
      num: '',
      yes: false,
      no: false,
      zhiwei: '理事',
      name: '',
      bh: '',
      form_name: '',
      sex: '',
      data1: '',
      people_kind: '',
      form_code: '',
      or: '',
      danwei: '',
      zhiwu: '',
      zzmm: '',
      xw: '',
      xl: '',
      zy: '',
      zc: '',
      yet_leader: '',
      txdz: '',
      yb: '',
      cz: '',
      lxdh: '',
      sj: '',
      dzyx: '',
      area: '',
      lb: '',
      lName: '',
      lPost: '',
      lPhone: '',
      lEmail: '',
      professions: '',
      category: [
        { name: '政府部门', isChecked: false },
        { name: '人民团体 行业协会', isChecked: false },
        { name: '质协系统', isChecked: false },
        { name: '专家学者', isChecked: false },
        { name: '企业组织', isChecked: false },
        { name: '新闻媒体', isChecked: false },
        { name: '其他', isChecked: false }
      ],

    }
  },
  mounted () {
    if (sessionStorage.getItem('dengJi_id')) {
      var dengJi_id = sessionStorage.getItem('dengJi_id');
    };
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    var data1 = {
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'director/numbertochinese',
      data: Qs.stringify(data1)
    }).then(response => {
      console.log(response.data);
      this.num = response.data;
    });

    var data = {
      director_id: dengJi_id,
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'director/directorinfoone',
      data: Qs.stringify(data)
    }).then(response => {
      console.log(response.data);
      if (response.data.state == 2) {
        for (var i in this.category) {
          if (this.category[i].name == response.data.data.professions) {
            this.category[i].isChecked = true;
          }
        };
        this.professions = response.data.data.professions;
        this.form_name = response.data.data.name;
        this.sex = response.data.data.sex;
        this.data1 = response.data.data.birthdate;
        this.people_kind = response.data.data.people;
        this.form_code = response.data.data.id_number;
        if (response.data.data.manager == 1) {
          this.yes = true;
        } else {
          this.no = true;
        };
        this.danwei = response.data.data.company_name;
        this.zhiwu = response.data.data.post;
        this.zzmm = response.data.data.politics_status;
        this.xw = response.data.data.degree;
        this.xl = response.data.data.education;
        this.zy = response.data.data.major;
        this.zc = response.data.data.professional_title;
        this.yet_leader = response.data.data.else_title;
        this.txdz = response.data.data.present_address;
        this.yb = response.data.data.postcode;
        this.lxdh = response.data.data.phone;
        this.cz = response.data.data.fax;
        this.sj = response.data.data.mobile;
        this.dzyx = response.data.data.email;
        this.area = response.data.data.work_experience;
        this.lName = response.data.data.other_name;
        this.lPost = response.data.data.other_post;
        this.lPhone = response.data.data.other_tel;
        this.lEmail = response.data.data.other_email;
        switch (Number(response.data.data.director_type)) {
          case 1:
            this.zhiwei = '理事';
            break;
          case 2:
            this.zhiwei = '常务理事';
            break;
          default:
            this.zhiwei = '副会长';
        }
      } else {
        this.$toast(response.data.msg);
      }
    })
  },
  methods: {
  },
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  font-style: normal;
}
ul,
li {
  list-style: none;
}
.pdf-preview {
  font-family: "宋体";
  width: 550px;
  padding: 0 40px 20px;
  margin: 0 auto;
  text-align: center;
  background-color: #fff;
}
.pdf-preview .title {
  font-size: 20px;
  padding: 30px 0 16px;
}
.category {
  /*// width: 500px;*/
  margin: 0 auto;
  color: #000;
  font-size: 8px;
}
.category .category-wrapper {
  display: flex;
  align-items: center;
  font-size: 8px;
  margin-bottom: 5px;
}
.category .category-wrapper input {
  margin-right: 1.5px;
}
.category .category-wrapper .category-title {
  padding-right: 7px;
  white-space: nowrap;
}
/* .category-list {
  display: flex;
  li {
    position: relative;
    padding-right: 7px;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }
} */
.pdf-details {
  border: 1px solid #000;
}
.pdf-details li {
  display: flex;
  align-items: stretch;
  border-style: hidden hidden solid hidden;
  border-width: 1px;
  border-color: #000;
  box-sizing: border-box;
}
.pdf-details li span {
  border-width: 1px;
  border-color: #000;
  padding: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-details li span:nth-child(2n) {
  border-style: hidden solid hidden solid;
}
.pdf-details li span:last-child {
  border-style: hidden hidden hidden solid;
}
.pdf-details li.first-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.first-line span:nth-child(2) {
  flex: 0 0 80px;
}

.pdf-details li.first-line span:nth-child(3) {
  flex: 0 0 50px;
}
.pdf-details li.first-line span:nth-child(4) {
  flex: 0 0 50px;
}
.pdf-details li.first-line span:nth-child(5) {
  flex: 0 0 80px;
}
.pdf-details li.first-line span:nth-child(6) {
  flex: 0 0 90px;
}
.pdf-details li.first-line span:nth-child(7) {
  flex: 0 0 60px;
}
.pdf-details li.first-line span:nth-child(8) {
  flex: 0 0 52px;
}
.pdf-details li.first-line span:nth-child(2n) {
  border-style: hidden solid hidden solid;
}
.pdf-details li.first-line span:last-child {
  border-style: hidden hidden hidden solid;
}
.pdf-details li.second-line span:nth-child(1),
.pdf-details li.third-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.second-line span:nth-child(2),
.pdf-details li.third-line span:nth-child(2) {
  flex: 0 0 263px;
}
.pdf-details li.second-line span:nth-child(3),
.pdf-details li.third-line span:nth-child(3) {
  flex: 0 0 90px;
}

.pdf-details li.second-line span:nth-child(4),
.pdf-details li.third-line span:nth-child(4) {
  flex: 0 0 112px;
  display: inline-flex;
  justify-content: space-around;
}
.pdf-details li.fourth-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.fourth-line span:nth-child(2) {
  flex: 0 0 75px;
}
.pdf-details li.fourth-line span:nth-child(3) {
  flex: 0 0 86px;
}
.pdf-details li.fourth-line span:nth-child(4) {
  flex: 0 0 100px;
}
.pdf-details li.fourth-line span:nth-child(5) {
  flex: 0 0 90px;
}
.pdf-details li.fourth-line span:nth-child(6) {
  flex: 0 0 112px;
}
.pdf-details li.fifth-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.fifth-line span:nth-child(2) {
  flex: 0 0 162px;
}
.pdf-details li.fifth-line span:nth-child(3) {
  flex: 0 0 191px;
}
.pdf-details li.fifth-line span:nth-child(4) {
  flex: 0 0 112px;
}
.pdf-details li.sixth-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.sixth-line span:nth-child(2) {
  flex: 0 0 283px;
}
.pdf-details li.sixth-line span:nth-child(3) {
  flex: 0 0 70px;
}
.pdf-details li.sixth-line span:nth-child(4) {
  flex: 0 0 112px;
}
.pdf-details li.seventh-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.seventh-line span:nth-child(2) {
  flex: 0 0 250px;
}
.pdf-details li.seventh-line span:nth-child(3) {
  flex: 0 0 65px;
}
.pdf-details li.seventh-line span:nth-child(4) {
  flex: 0 0 150px;
}
.pdf-details li.eighth-line span:nth-child(1) {
  flex: 0 0 80px;
}
.pdf-details li.eighth-line span:nth-child(2) {
  flex: 0 0 179px;
}
.pdf-details li.eighth-line span:nth-child(3) {
  flex: 0 0 70px;
}
.pdf-details li.eighth-line span:nth-child(4) {
  flex: 0 0 126px;
}
.pdf-details li.nineth-line .nine-name {
  flex: 0 0 60px;
  padding: 10px;
  border-right: solid 1px #000;
}
.pdf-details li.nineth-line .nine-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  justify-content: flex-start;
  text-indent: 20px;
  padding: 0;
}
.pdf-details li.nineth-line .nine-tit {
  width: 100%;
  padding: 0;
  border-style: hidden hidden solid hidden;
}
.pdf-details li.nineth-line span {
  flex: 1;
  height: 20px;
  padding: 0;
}
.pdf-details li.nineth-line span:last-child {
  border: none;
}
.pdf-details li.nineth-line .letter-style {
  justify-content: flex-end;
  letter-spacing: 46px;
}
.pdf-details li.nineth-line .nine-desc {
  border: none;
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
  text-indent: 20px;
  min-height: 90px;
  width: 100%;
}
.pdf-details li.tenth-line span:nth-child(1) {
  flex: 0 0 30px;
  padding: 10px;
}
.pdf-details li.tenth-line span:nth-child(2) {
  flex: 0 0 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pdf-details li.tenth-line span:nth-child(3) {
  flex: 0 0 30px;
}
.pdf-details li.tenth-line span:nth-child(4) {
  flex: 0 0 212px;
  display: flex;
  flex-direction: column;
}
.pdf-details li.tenth-line .desc {
  text-align: left;
  padding: 10px 5px;
}
.pdf-details li.tenth-line .signature {
  align-self: flex-end;
  display: flex;
  width: 90%;
  justify-content: space-between;
}

.footer {
  text-align: left;
  line-height: 2;
  font-size: 10px;
}
.footer em {
  padding-left: 10px;
}
.footer span {
  display: inline-block;
  width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/pdfTmp.vue